import { useQuery } from '@tanstack/react-query';
import { createClient } from '../engine/api/client';

// A team invite seen BEFORE the invitee has an account (GET /auth/invite/:token, public; the token
// in the link is the capability). It tells the invite and login pages which organisation and email
// the account is for and how that organisation signs in, so accepting an invite creates the account
// for that organisation — never an org-founding detour.

export interface InvitePreview {
  organisation: string;
  tenant_id: string;
  email: string;
  role: string;
  expires_at: string;
  sign_in: 'password' | 'halo';
}

const anon = createClient(async () => null);

export const INVITE_TOKEN_KEY = 'hf.invite_token';

export function useInvitePreview(token: string | null) {
  return useQuery({
    queryKey: ['invite-preview', token],
    enabled: Boolean(token),
    retry: false,
    staleTime: 60_000,
    queryFn: () => anon.request<InvitePreview>(`/auth/invite/${encodeURIComponent(token ?? '')}`),
  });
}

/** Where an invitee lands after signing in or confirming their email: back on the invite. */
export const invitePath = (token: string) => `/invite?token=${encodeURIComponent(token)}`;
